// extracted by mini-css-extract-plugin
module.exports = {"box":"today_box_TTVE2","dataBox":"today_dataBox_15J4A","txtBox":"today_txtBox_2NKKx","noDataBox":"today_noDataBox_g-r1-","desc":"today_desc_nvE6A"};